export default {
  namespaced: true,
  state: {
    userId: '',
    userName: '',
    roleName: '',
    token: ''
  },
  mutations: {
    SET_USER_INFO: (state, payload) => {
      Object.keys(payload).forEach((item) => {
        state[item] = payload[item]
      })
    }
  },
  actions: {
  }
}
